import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IModule } from "src/models/General/Module.models";

interface modulestate {
  modules: IModule[];
  moduleToEdit: IModule | null;
}

const initialState: modulestate = {
  modules: [],
  moduleToEdit: null,
};

const moduleSlice = createSlice({
  name: "Module",
  initialState,
  reducers: {
    setModuleList: (state, action: PayloadAction<IModule[]>) => {
      state.modules = action.payload;
    },
    concatListModule: (
      state: modulestate,
      action: PayloadAction<IModule[]>
    ) => {
      state.modules = [...state.modules.concat(action.payload)];
    },
    setModuleToEdit: (state, action: PayloadAction<IModule | null>) => {
      state.moduleToEdit = action.payload;
    },
    addModule: (state, action: PayloadAction<IModule>) => {
      state.modules.push(action.payload);
    },
    updateModule: (state, action: PayloadAction<IModule>) => {
      let itemIndex = state.modules.findIndex(
        item => item.moduleId === action.payload.moduleId
      );
      if (itemIndex !== -1) state.modules[itemIndex] = action.payload;
    },
    deleteModule: (state, action: PayloadAction<number>) => {
      const newArray = state.modules.filter(
        item => item.moduleId !== action.payload
      );
      state.modules = newArray;
    },
  },
});

export const {
  setModuleList,
  concatListModule,
  setModuleToEdit,
  addModule,
  updateModule,
  deleteModule,
} = moduleSlice.actions;

export default moduleSlice.reducer;
